import { type Question } from '@/types'

import { generateId } from '../utils'
import { buildFunctionDescriptionByFormula } from './buildFunctionDescriptionByFormula'
import { extractQRValues } from './extractQRValues'
import { getQuestionInfo } from './getQuestionInfo'
import { parseFormulaToTokens } from './parseFormulaToTokens'

export const convertFormulaToHtml = (
  questions: Question[],
  formula: string
) => {
  const tokens = parseFormulaToTokens(formula)
  return tokens
    .map(({ type, value }) => {
      switch (type) {
        case 'number':
          return `<div data-type="${type}" class="formula-number">${value}</div>`

        case 'operator':
          return `<div data-type="${type}" class="formula-operator">${value}</div>`

        case 'field': {
          const index = value.slice(1)
          const questionsFilteredWithoutDatetime = questions.filter(
            (question) => {
              const questionType = question.question_type.question_type
              if (questionType === 'datetime') return false
              return true
            }
          )

          let dataAttr = ''
          let title = ''
          let classAttr = ''
          if (/^QR\d+_\d+$/.test(value)) {
            const questionInfo = getQuestionInfo(
              questionsFilteredWithoutDatetime,
              value
            )
            dataAttr = `data-question-id="${questionInfo?.questionId}" data-row-order="${questionInfo?.rowOrder}`
            title = questionInfo?.description || ''
          } else if (/^Q\d+$/.test(value)) {
            const questionInfo = getQuestionInfo(
              questionsFilteredWithoutDatetime,
              value
            )
            dataAttr = `data-form-index="${index}"`
            title = questionInfo?.description || ''
          } else if (/^R\d+$/.test(value)) {
            const rowInfo = getQuestionInfo(
              questionsFilteredWithoutDatetime,
              value
            )
            dataAttr = `data-row-form-index="${index}"`
            title = rowInfo?.description || ''
          }

          if (title.toLowerCase().includes('removed')) {
            classAttr = 'class="removed-field"'
          }
          return `<div data-type="field" contenteditable="false" data-description="${title}" ${dataAttr} ${classAttr}>${title}</div>`
        }

        case 'function': {
          const { qValues, rValues, qrPairs } = extractQRValues(value)
          const newDescription = buildFunctionDescriptionByFormula(
            questions,
            value,
            qValues,
            rValues,
            qrPairs
          )
          return `<div data-type="function" data-id="${generateId()}" contenteditable="false" data-value="${value}" data-description="${newDescription}" class="formula-function">
          ${newDescription}
        </div>`
        }

        case 'parentheses':
          return `<div data-type="parentheses" class="formula-parentheses">${value}</div>`

        default:
          throw new Error('Unsupported token type')
      }
    })
    .join('')
}
